<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">

    </div>

    <div class="nav material2">
        <span style="font-weight: bold;">{{'Start date'|translate}}</span>
        <mat-calendar [selected]="startDate" (selectedChange)="changeStartDate($event);"></mat-calendar>
    </div>

    <div class="nav material2">
        <span style="font-weight: bold;">{{'End date'|translate}}</span>
        <mat-calendar [selected]="endDate" (selectedChange)="changeEndDate($event);"></mat-calendar>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
